import AllServiceCenterAppConfig from './all-service-center/DatasAppConfig';
import ProductsAppConfig from './products/DatasAppConfig';
import OrdersAppConfig from './orders/OrdersAppConfig';

const ServiceCenterAppConfig = [AllServiceCenterAppConfig, ProductsAppConfig, OrdersAppConfig];

export default ServiceCenterAppConfig;
